// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-availability-overlay-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1299;
  background-color: rgba(0, 0, 0, 0.2); /* bg-black/20 */
  backdrop-filter: blur(12px); /* backdrop-blur-sm */
  display: flex;
  justify-content: flex-end;
}

.menu-availability-overlay-backdrop {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}

.menu-availability-drawer {
  position: relative;
  z-index: 2;
  width: 80%;
  height: 100%;
  background-color: #f8fafc; /* bg-slate-50 */
  box-shadow: -10px 0 50px -12px rgba(0, 0, 0, 0.25); /* shadow-2xl */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-left: 1px solid rgba(255, 255, 255, 0.2); /* border-l border-white/20 */
  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
    sans-serif;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

/* Header / Top Bar */
.menu-availability-header {
  border-bottom: 1px solid #e2e8f0; /* border-slate-200 */
  background-color: #ffffff; /* bg-white */
  padding: 16px 24px; /* px-6 py-4 */
  position: relative;
  z-index: 20; /* above subbar so filter dropdown isn't clipped behind it */
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px; /* gap-6 */
}

.menu-availability-title {
  font-size: 20px; /* text-[20px] */
  font-weight: 700; /* font-bold */
  line-height: 1.25; /* leading-tight */
  letter-spacing: -0.03em; /* tracking-[-0.03em] */
  color: #0f172a; /* text-slate-900 */
  margin: 0;
}

.menu-availability-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  height: 40px;
  width: 40px;
  border-radius: 9999px; /* rounded-full */
  color: #64748b; /* text-slate-500 */
  background: transparent;
  cursor: pointer;
}

.menu-availability-close-btn:hover {
  background-color: #f1f5f9; /* hover:bg-slate-100 */
}

.menu-availability-close-icon {
  height: 20px;
  width: 20px;
  stroke: currentColor;
  stroke-width: 2;
}

.menu-availability-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Sub-header / Filters Bar */
.menu-availability-subbar {
  border-bottom: 1px solid #e2e8f0; /* border-slate-200 */
  background-color: rgba(248, 250, 252, 0.8); /* bg-slate-50/80 */
  backdrop-filter: blur(8px);
  padding: 12px 24px; /* px-6 py-3 */
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px; /* gap-4 */
}

.menu-availability-subbar-left {
  display: flex;
  align-items: center;
  gap: 16px; /* gap-4 */
}

.menu-availability-tabs-container {
  display: flex;
  align-items: center;
  border-radius: 16px; /* rounded-[16px] */
  background-color: #f1f5f9; /* bg-slate-100 */
  padding: 4px; /* p-1 */
}

.menu-availability-tab-btn {
  padding: 6px 16px; /* px-4 py-1.5 */
  border-radius: 12px; /* rounded-[12px] */
  font-size: 14px; /* text-sm */
  font-weight: 600; /* font-semibold */
  transition: all 0.2s ease;
  border: none;
  cursor: pointer;
  background: transparent;
  color: #64748b; /* text-slate-500 */
}

.menu-availability-tab-btn:hover {
  color: #334155; /* hover:text-slate-700 */
}

.menu-availability-tab-btn.active {
  background-color: #ffffff; /* bg-white */
  color: #0f172a; /* text-slate-900 */
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px -1px rgba(0, 0, 0, 0.1); /* shadow-sm */
}

.menu-availability-subbar-divider {
  height: 32px; /* h-8 */
  width: 1px; /* w-px */
  background-color: #e2e8f0; /* bg-slate-200 */
}

.menu-availability-status-switch-wrapper {
  display: flex;
  align-items: center;
  gap: 12px; /* gap-3 */
  padding: 0 8px; /* px-2 */
}

.menu-availability-status-switch-info {
  min-width: 0;
}

.menu-availability-status-switch-title {
  font-size: 14px; /* text-sm */
  font-weight: 600; /* font-semibold */
  line-height: 1; /* leading-none */
  color: #059669; /* text-emerald-600 */
  margin: 0;
}

.menu-availability-status-switch-subtitle {
  margin-top: 4px; /* mt-1 */
  font-size: 10px; /* text-[10px] */
  color: #94a3b8; /* text-slate-400 */
  margin-bottom: 0;
}

/* Switch Styles (emerald style switch) */
.menu-availability-status-toggle {
  all: unset;
  display: inline-flex;
  height: 17px; /* h-5 */
  width: 33px; /* w-9 */
  shrink: 0;
  cursor: pointer;
  align-items: center;
  border-radius: 9999px; /* rounded-full */
  border: 2px solid transparent;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
  transition: all 0.2s ease;
  background-color: #cbd5e1; /* slate-300 / bg-input */
}

.menu-availability-status-toggle.active {
  background-color: #10b981; /* bg-emerald-500 */
}

.menu-availability-status-toggle-knob {
  pointer-events: none;
  display: block;
  height: 16px; /* h-4 */
  width: 16px; /* w-4 */
  border-radius: 9999px; /* rounded-full */
  background-color: #ffffff; /* bg-background */
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1); /* shadow-lg */
  transition: transform 0.2s ease;
  transform: translateX(0);
}

.menu-availability-status-toggle-knob.active {
  transform: translateX(16px); /* translate-x-4 */
}

.menu-availability-subbar-right {
  display: flex;
  align-items: center;
  gap: 12px; /* gap-3 */
}

.menu-availability-search-wrapper {
  position: relative;
  width: 256px; /* w-64 */
}

.menu-availability-search-svg {
  position: absolute;
  left: 12px; /* left-3 */
  top: 50%;
  transform: translateY(-50%); /* -translate-y-1/2 */
  height: 16px; /* h-4 */
  width: 16px; /* w-4 */
  color: #94a3b8; /* text-slate-400 */
  pointer-events: none;
}

.menu-availability-search-input {
  display: flex;
  width: 100%;
  border: 1px solid #e2e8f0; /* border-slate-200 */
  background-color: #ffffff; /* bg-white */
  padding: 8px 12px 8px 36px; /* px-3 py-1 pl-9 */
  font-size: 14px; /* text-sm */
  line-height: 1.25;
  border-radius: 20px; /* rounded-xl */
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
  outline: none;
  transition: all 0.2s ease;
}

.menu-availability-search-input:focus {
  border-color: #94a3b8;
  box-shadow: 0 0 0 2px rgba(148, 163, 184, 0.15);
}

/* Add Menu Button */
.menu-availability-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px; /* gap-2 */
  height: 38px;
  padding: 0 16px;
  border-radius: 12px; /* rounded-xl */
  font-size: 14px; /* text-sm */
  font-weight: 600; /* font-semibold */
  color: #0f172a; /* text-slate-900 */
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.menu-availability-add-btn:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

.menu-availability-add-icon {
  width: 16px;
  height: 16px;
  stroke: currentColor;
  stroke-width: 2.5;
}

/* Content Area */
.menu-availability-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* Categories Sidebar */
.menu-availability-categories {
  width: 256px; /* w-64 */
  background-color: #ffffff; /* bg-white */
  border-right: 1px solid #e2e8f0; /* border-slate-200 */
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 24px 16px; /* py-6 px-4 */
  gap: 4px; /* space-y-1 */
  height: 100%;
}

.menu-availability-categories::-webkit-scrollbar {
  width: 6px;
}

.menu-availability-categories::-webkit-scrollbar-track {
  background: transparent;
}

.menu-availability-categories::-webkit-scrollbar-thumb {
  background-color: rgba(148, 163, 184, 0.5); /* slate-400 with opacity */
  border-radius: 20px;
}

.menu-availability-categories::-webkit-scrollbar-thumb:hover {
  background-color: rgba(148, 163, 184, 0.8);
}

.menu-availability-category-item {
  width: 100%;
  text-align: left;
  padding: 12px 16px; /* px-4 py-3 */
  border-radius: 20px; /* rounded-xl */
  font-size: 14px; /* text-sm */
  font-weight: 500; /* font-medium */
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border: none;
  background: transparent;
  color: #475569; /* text-slate-600 */
}

.menu-availability-category-item:hover {
  background-color: #f8fafc; /* hover:bg-slate-50 */
  color: #0f172a; /* hover:text-slate-900 */
}

.menu-availability-category-item.active {
  background-color: #0f172a; /* bg-slate-900 */
  color: #ffffff; /* text-white */
  box-shadow: 0 10px 15px -3px rgba(15, 23, 42, 0.2); /* shadow-lg shadow-slate-900/20 */
}

.menu-availability-category-chevron {
  width: 16px; /* w-4 h-4 */
  height: 16px;
  color: rgba(255, 255, 255, 0.5); /* text-white/50 */
  stroke: currentColor;
  stroke-width: 2;
}

/* Products List Area */
.menu-availability-products {
  flex: 1;
  background-color: #f8fafc; /* bg-slate-50 */
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 32px; /* p-8 */
}

.menu-availability-products::-webkit-scrollbar {
  width: 6px;
}

.menu-availability-products::-webkit-scrollbar-track {
  background: transparent;
}

.menu-availability-products::-webkit-scrollbar-thumb {
  background-color: rgba(148, 163, 184, 0.5); /* slate-400 with opacity */
  border-radius: 20px;
}

.menu-availability-products::-webkit-scrollbar-thumb:hover {
  background-color: rgba(148, 163, 184, 0.8);
}

.menu-availability-products-list {
  display: flex;
  flex-direction: column;
  gap: 16px; /* space-y-4 */
}

/* Product Card */
.menu-availability-product-row {
  display: flex;
  align-items: center;
  gap: 24px; /* gap-6 */
  padding: 16px; /* p-4 */
  background-color: #ffffff; /* bg-white */
  border-radius: 16px; /* rounded-2xl */
  border: 1px solid rgba(226, 232, 240, 0.6); /* border border-slate-200/60 */
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
  transition: all 0.2s ease;
}

.menu-availability-product-row:hover {
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.05),
    0 2px 4px -2px rgba(0, 0, 0, 0.05); /* shadow-md */
  border-color: #cbd5e1; /* hover:border-slate-300 */
}

/* Product Image */
.menu-availability-product-image-container {
  width: 64px; /* w-16 */
  height: 64px; /* h-16 */
  border-radius: 20px; /* rounded-xl */
  overflow: hidden;
  background-color: #f1f5f9; /* bg-slate-100 */
  flex-shrink: 0;
}

.menu-availability-product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Details */
.menu-availability-product-details {
  flex: 1;
  min-width: 0;
}

.menu-availability-product-title-row {
  display: flex;
  align-items: center;
  gap: 8px; /* gap-2 */
  margin-bottom: 4px; /* mb-1 */
}

.menu-availability-product-name {
  font-size: 16px; /* text-base */
  font-weight: 700; /* font-bold */
  color: #0f172a; /* text-slate-900 */
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-availability-product-badge {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  border-radius: 20px; /* rounded-md */
  padding: 2px 10px; /* px-2.5 py-0.5 */
  font-size: 10px; /* text-[10px] */
  font-weight: 600; /* font-semibold */
  color: #64748b; /* text-slate-500 */
  border: 1px solid #e2e8f0; /* border-slate-200 */
}

.menu-availability-product-price {
  font-size: 14px; /* text-sm */
  font-weight: 600; /* font-semibold */
  color: #475569; /* text-slate-600 */
  margin: 0;
}

/* Status / Switch Container */
.menu-availability-product-status-container {
  display: flex;
  align-items: center;
  gap: 16px; /* gap-4 */
  border-left: 1px solid #f1f5f9; /* border-l border-slate-100 */
  padding-left: 24px; /* pl-6 */
  flex-shrink: 0;
}

.menu-availability-product-status-text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px; /* gap-1 */
  margin-right: 8px; /* mr-2 */
}

.menu-availability-status-label-text {
  font-size: 12px; /* text-xs */
  font-weight: 700; /* font-bold */
  text-transform: uppercase; /* uppercase */
  letter-spacing: 0.05em; /* tracking-wider */
}

.menu-availability-status-label-text.on-sale {
  color: #059669; /* text-emerald-600 */
}

.menu-availability-status-label-text.unavailable {
  color: #94a3b8; /* text-slate-400 */
}

.menu-availability-status-subtext {
  font-size: 10px; /* text-[10px] */
  color: #94a3b8; /* text-slate-400 */
}

/* Toggle Switch inside card */
.menu-availability-switch-button {
  all: unset;
  display: inline-flex;
  height: 20px; /* h-5 */
  width: 36px; /* w-9 */
  shrink: 0;
  cursor: pointer;
  align-items: center;
  border-radius: 9999px; /* rounded-full */
  border: 2px solid transparent;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
  transition: all 0.2s ease;
  background-color: #cbd5e1; /* bg-input */
}

.menu-availability-switch-button.active {
  background-color: #10b981; /* bg-emerald-500 */
}

.menu-availability-switch-button-knob {
  pointer-events: none;
  display: block;
  height: 16px; /* h-4 */
  width: 16px; /* w-4 */
  border-radius: 9999px; /* rounded-full */
  background-color: #ffffff; /* bg-background */
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1); /* shadow-lg */
  transition: transform 0.2s ease;
  transform: translateX(0);
}

.menu-availability-switch-button-knob.active {
  transform: translateX(16px); /* translate-x-4 */
}

.menu-availability-oos-badge {
  align-items: center;
  display: inline-flex;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 9999px;
  background-color: #fee2e2;
  color: #ef4444;
  border: 1px solid #fecaca;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.menu-availability-oos-badge:hover {
  background-color: #fecaca;
  border-color: #fca5a5;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.mad-popover-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #ffffff;
  min-width: 200px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-shadow:
    0 4px 6px -1px rgb(0 0 0 / 0.1),
    0 2px 4px -2px rgb(0 0 0 / 0.1);
}

.mad-popover-variant-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mad-popover-variant-name {
  font-size: 12px;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding-bottom: 4px;
  border-bottom: 1px solid #f1f5f9;
}

.mad-popover-channel-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.mad-popover-channel-tag {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 9999px;
  background-color: #fef2f2;
  color: #ef4444;
  border: 1px solid #fee2e2;
  white-space: nowrap;
}

/* Variant Modal */
.menu-availability-variant-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(15, 23, 42, 0.3); /* Slate-900 with transparency */
  backdrop-filter: blur(4px);
  z-index: 1399;
}

.menu-availability-variant-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  max-width: 90%;
  max-height: 80vh;
  background-color: #ffffff;
  border-radius: 20px; /* rounded-2xl */
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  z-index: 1400;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
    sans-serif;
}

.menu-availability-variant-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  background-color: #ffffff;
}

.menu-availability-variant-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.menu-availability-variant-close {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 9999px;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.menu-availability-variant-close:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.menu-availability-variant-content {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
  background-color: #f8fafc;
}

.menu-availability-variant-section {
  margin-bottom: 24px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.02);
}

.menu-availability-variant-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.menu-availability-variant-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.menu-availability-variant-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.menu-availability-channel-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.menu-availability-channel-item.toggling {
  opacity: 0.6;
  pointer-events: none;
}

.menu-availability-channel-name {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}

.menu-availability-channel-sale-price {
  font-size: 14px;
  font-weight: 700;
  color: #059669;
  margin-left: auto;
  margin-right: 16px;
}

.menu-availability-channel-status-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.menu-availability-channel-status {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 9999px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.menu-availability-channel-status.in-stock {
  background-color: #d1fae5;
  color: #065f46;
}

.menu-availability-channel-status.out-of-stock {
  background-color: #fee2e2;
  color: #991b1b;
}

/* Modal Actions */
.menu-availability-variant-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  background-color: #ffffff;
}

.menu-availability-btn {
  padding: 10px 18px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.menu-availability-btn-mark-in-stock {
  background-color: #d1fae5;
  border-color: #a7f3d0;
  color: #065f46;
}

.menu-availability-btn-mark-in-stock:hover:not(:disabled) {
  background-color: #059669;
  color: #ffffff;
  border-color: #059669;
}

.menu-availability-btn-mark-in-stock:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.menu-availability-btn-mark-oos {
  background-color: #fee2e2;
  border-color: #fecaca;
  color: #991b1b;
}

.menu-availability-btn-mark-oos:hover:not(:disabled) {
  background-color: #dc2626;
  color: #ffffff;
  border-color: #dc2626;
}

.menu-availability-btn-mark-oos:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.menu-availability-btn-cancel {
  background-color: #f1f5f9;
  border-color: #e2e8f0;
  color: #475569;
}

.menu-availability-btn-cancel:hover {
  background-color: #e2e8f0;
  color: #0f172a;
}

/* Loading State */
.menu-availability-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.menu-availability-loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}

/* No Results */
.menu-availability-no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #64748b;
}

.menu-availability-no-results p {
  margin: 8px 0 0 0;
  font-size: 14px;
  font-weight: 500;
}

/* Info icon tooltip */
.mad-info-tooltip {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: default;
  flex-shrink: 0;
}

.mad-info-tooltip-box {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #1e293b;
  color: #f8fafc;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  padding: 7px 12px;
  border-radius: 8px;
  width: max-content;
  max-width: 600px;
  white-space: normal;
  word-break: break-word;
  text-align: center;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  animation: mad-tooltip-in 0.12s ease forwards;
}

.mad-info-tooltip-box::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1e293b;
}

@keyframes mad-tooltip-in {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* ── Dark mode ── */
.dark .menu-availability-drawer {
  background-color: #0f172a;
  border-left-color: #334155;
}

.dark .menu-availability-header {
  background-color: #1e293b;
  border-bottom-color: #334155;
}

.dark .menu-availability-title {
  color: #f1f5f9;
}

.dark .menu-availability-close-btn {
  color: #94a3b8;
}

.dark .menu-availability-close-btn:hover {
  background-color: #334155;
}

.dark .menu-availability-add-btn {
  background-color: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

.dark .menu-availability-add-btn:hover {
  background-color: #334155;
  border-color: #475569;
}

.dark .menu-availability-subbar {
  background-color: rgba(15, 23, 42, 0.8);
  border-bottom-color: #334155;
}

.dark .menu-availability-tabs-container {
  background-color: #0f172a;
}

.dark .menu-availability-tab-btn {
  color: #64748b;
}

.dark .menu-availability-tab-btn:hover {
  color: #cbd5e1;
}

.dark .menu-availability-tab-btn.active {
  background-color: #1e293b;
  color: #f1f5f9;
  box-shadow: 0 1px 3px rgba(0,0,0,0.4);
}

.dark .menu-availability-subbar-divider {
  background-color: #334155;
}

.dark .menu-availability-status-switch-subtitle {
  color: #64748b;
}

.dark .menu-availability-search-input {
  background-color: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

.dark .menu-availability-search-input::placeholder {
  color: #64748b;
}

.dark .menu-availability-search-input:focus {
  border-color: #475569;
}

.dark .menu-availability-categories {
  background-color: #1e293b;
  border-right-color: #334155;
}

.dark .menu-availability-category-item {
  color: #94a3b8;
}

.dark .menu-availability-category-item:hover {
  background-color: #0f172a;
  color: #e2e8f0;
}

.dark .menu-availability-category-item.active {
  background-color: #3b82f6;
  color: #ffffff;
}

.dark .menu-availability-products {
  background-color: #0f172a;
}

.dark .menu-availability-product-row {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .menu-availability-product-row:hover {
  border-color: #475569;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.dark .menu-availability-product-image-container {
  background-color: #334155;
}

.dark .menu-availability-product-name {
  color: #f1f5f9;
}

.dark .menu-availability-product-badge {
  color: #94a3b8;
  border-color: #334155;
  background: #0f172a;
}

.dark .menu-availability-product-price {
  color: #94a3b8;
}

.dark .menu-availability-product-status-container {
  border-left-color: #334155;
}

.dark .menu-availability-status-subtext {
  color: #64748b;
}

.dark .menu-availability-no-results {
  color: #64748b;
}

/* Variant modal */
.dark .menu-availability-variant-modal {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .menu-availability-variant-header {
  background-color: #1e293b;
  border-bottom-color: #334155;
}

.dark .menu-availability-variant-title {
  color: #f1f5f9;
}

.dark .menu-availability-variant-close {
  color: #94a3b8;
}

.dark .menu-availability-variant-close:hover {
  background-color: #334155;
  color: #f1f5f9;
}

.dark .menu-availability-variant-content {
  background-color: #0f172a;
}

.dark .menu-availability-variant-section {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .menu-availability-variant-section-title {
  color: #f1f5f9;
}

.dark .menu-availability-channel-item {
  background-color: #0f172a;
  border-color: #334155;
}

.dark .menu-availability-channel-name {
  color: #e2e8f0;
}

.dark .menu-availability-variant-actions {
  background-color: #1e293b;
  border-top-color: #334155;
}

.dark .menu-availability-btn-cancel {
  background-color: #334155;
  border-color: #475569;
  color: #94a3b8;
}

.dark .menu-availability-btn-cancel:hover {
  background-color: #475569;
  color: #f1f5f9;
}

/* mad-dialog */
.dark .mad-dialog {
  background: #0f172a;
}

.dark .mad-dialog-header {
  background: #1e293b;
  border-bottom-color: #334155;
}

.dark .mad-dialog-title {
  color: #f1f5f9;
}

.dark .mad-dialog-body {
  background: #0f172a;
}

.dark .mad-dialog-section {
  background: #1e293b;
}

.dark .mad-section-heading {
  color: #e2e8f0;
}

.dark .mad-section-hint {
  color: #64748b;
}

.dark .mad-vr-row {
  background: #1e293b;
  border-color: #334155;
}

.dark .mad-vr-row:hover:not(.mad-vr-row--checked) {
  border-color: #475569;
}

.dark .mad-vr-row--checked {
  background: #2d1b1b;
  border-color: #7f1d1d;
}

.dark .mad-vr-name {
  color: #e2e8f0;
}

.dark .mad-variant-price {
  color: #64748b;
}

.dark .mad-vr-channels {
  border-top-color: #334155;
}

.dark .mad-ch-name {
  color: #94a3b8;
}

/* Responsive */
@media (max-width: 768px) {
  .menu-availability-drawer {
    width: 100%;
  }

  .menu-availability-subbar {
    flex-direction: column;
    align-items: stretch;
  }

  .menu-availability-subbar-left {
    flex-wrap: wrap;
  }

  .menu-availability-categories {
    width: 180px;
  }

  .menu-availability-search-wrapper {
    width: 100%;
  }
}

/* ── Variant Modal (mad-dialog) ── */
.mad-dialog-overlay {
  position: fixed;
  inset: 0;
  z-index: 1400;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
}

.mad-dialog {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1401;
  width: 100%;
  max-width: 640px;
  background: #f8fafc;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.mad-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  background: #fff;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.mad-dialog-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.02em;
}

.mad-dialog-close-abs {
  position: absolute;
  top: 16px;
  right: 16px;
  display: grid;
  place-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.15s ease;
}

.mad-dialog-close-abs:hover {
  opacity: 1;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.mad-dialog-body {
  overflow-y: auto;
  background: #f8fafc;
}

.mad-dialog-section {
  background: #fff;
  padding: 24px;
}

.mad-section-heading {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin: 0 0 16px 0;
}

.mad-section-hint {
  font-size: 12px;
  color: #94a3b8;
  margin: 12px 0 0 0;
}

/* Variant rows */
.mad-variant-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mad-vr-row {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background 0.15s ease;
  overflow: hidden;
}

.mad-vr-row:hover:not(.mad-vr-row--checked) {
  border-color: #cbd5e1;
}

.mad-vr-row--checked {
  background: #fff1f2;
  border-color: #fecdd3;
}

.mad-vr-top {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
}

.mad-vr-checkbox {
  display: grid;
  place-content: center;
  width: 16px;
  height: 16px;
  min-width: 16px;
  border-radius: 30px;
  border: 1px solid #79adec;
  background: #fff;
  color: transparent;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.mad-vr-checkbox--checked {
  background: #dc2626;
  border-color: #dc2626;
  color: #fff;
}

.mad-vr-name {
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
}

.mad-vr-name--checked {
  color: #991b1b;
}

.mad-variant-price {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 400;
}

/* Status badges */
.mad-status-badge {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  padding: 2px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid transparent;
  flex-shrink: 0;
}

.mad-status--on-sale {
  background: #ecfdf5;
  color: #059669;
  border-color: #a7f3d0;
}

.mad-status--oos {
  background: #fff7ed;
  color: #ea580c;
  border-color: #fed7aa;
}

/* Channels sub-section inside variant row */
.mad-vr-channels {
  border-top: 1px solid #f1f5f9;
  padding: 8px 14px 10px 40px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: rgba(0, 0, 0, 0.01);
}

.mad-vr-row--checked .mad-vr-channels {
  border-top-color: #fecdd3;
  background: rgba(254, 202, 202, 0.08);
}

.mad-vr-channel {
  display: flex;
  align-items: center;
  gap: 10px;
  transition: opacity 0.15s ease;
}

.mad-vr-channel.toggling {
  opacity: 0.5;
  pointer-events: none;
}

.mad-ch-name-price-container {
  flex: 1;
  display: flex;
  gap: 0.25rem;
}

.mad-ch-name {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  /* flex: 1; */
}

.mad-ch-price {
  font-size: 12px;
  font-weight: 700;
  color: oklch(70.4% 0.04 256.788);
}

.mad-ch-status {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.mad-ch-status.in-stock {
  background: #d1fae5;
  color: #065f46;
}

.mad-ch-status.out-of-stock {
  background: hsl(210 40% 96.1%);
  color: hsl(222 47% 11%);
}

/* Footer */
.mad-dialog-footer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  background: #fff;
  border-top: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.mad-footer-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  height: 44px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  flex: 1;
  border: 1px solid transparent;
  transition: background 0.15s ease;
}

.mad-footer-btn--cancel {
  background: #fff;
  border-color: #e2e8f0;
  color: #475569;
}

.mad-footer-btn--cancel:hover {
  background: #f8fafc;
}

.mad-footer-btn--confirm {
  background: #0f172a;
  color: #fff;
  border-color: #0f172a;
}

.mad-footer-btn--confirm:hover:not(:disabled) {
  background: #1e293b;
}

.mad-footer-btn--confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Variant group labels (shown when product has multiple variants) ── */
.mad-vs-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 4px;
}

.mad-vs-header {
  padding: 4px 2px 2px 2px;
}

.mad-vs-name {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.07em;
}

/* ── Channel checkbox rows ── */
.mad-ch-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background 0.15s ease;
  user-select: none;
}

.mad-ch-row:hover:not(.mad-ch-row--checked):not(.mad-ch-row--toggling) {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.mad-ch-row--checked {
  background: #fff1f2;
  border-color: #fecdd3;
}

.mad-ch-row--toggling {
  opacity: 0.5;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/table-layout/components/MenuAvailabilityDrawer/MenuAvailabilityDrawer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,oCAAoC,EAAE,gBAAgB;EACtD,2BAA2B,EAAE,qBAAqB;EAClD,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,yBAAyB,EAAE,gBAAgB;EAC3C,kDAAkD,EAAE,eAAe;EACnE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+CAA+C,EAAE,6BAA6B;EAC9E,qDAAqD;EACrD;cACY;AACd;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,gCAAgC,EAAE,qBAAqB;EACvD,yBAAyB,EAAE,aAAa;EACxC,kBAAkB,EAAE,cAAc;EAClC,kBAAkB;EAClB,WAAW,EAAE,4DAA4D;EACzE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS,EAAE,UAAU;AACvB;;AAEA;EACE,eAAe,EAAE,gBAAgB;EACjC,gBAAgB,EAAE,cAAc;EAChC,iBAAiB,EAAE,kBAAkB;EACrC,uBAAuB,EAAE,uBAAuB;EAChD,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,qBAAqB,EAAE,iBAAiB;EACxC,cAAc,EAAE,mBAAmB;EACnC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC,EAAE,qBAAqB;EACvD,0CAA0C,EAAE,mBAAmB;EAC/D,0BAA0B;EAC1B,kBAAkB,EAAE,cAAc;EAClC,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS,EAAE,UAAU;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,UAAU;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAE,mBAAmB;EACxC,yBAAyB,EAAE,iBAAiB;EAC5C,YAAY,EAAE,QAAQ;AACxB;;AAEA;EACE,iBAAiB,EAAE,gBAAgB;EACnC,mBAAmB,EAAE,mBAAmB;EACxC,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,kBAAkB;EACpC,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE,yBAAyB,EAAE,aAAa;EACxC,cAAc,EAAE,mBAAmB;EACnC;;qCAEmC,EAAE,cAAc;AACrD;;AAEA;EACE,YAAY,EAAE,QAAQ;EACtB,UAAU,EAAE,SAAS;EACrB,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,UAAU;EACrB,cAAc,EAAE,SAAS;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,iBAAiB;EACjC,cAAc,EAAE,qBAAqB;EACrC,SAAS;AACX;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,eAAe,EAAE,gBAAgB;EACjC,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,UAAU;EACV,oBAAoB;EACpB,YAAY,EAAE,QAAQ;EACtB,WAAW,EAAE,QAAQ;EACrB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,qBAAqB,EAAE,iBAAiB;EACxC,6BAA6B;EAC7B,2CAA2C,EAAE,cAAc;EAC3D,yBAAyB;EACzB,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY,EAAE,QAAQ;EACtB,WAAW,EAAE,QAAQ;EACrB,qBAAqB,EAAE,iBAAiB;EACxC,yBAAyB,EAAE,kBAAkB;EAC7C;;qCAEmC,EAAE,cAAc;EACnD,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B,EAAE,kBAAkB;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,UAAU;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,SAAS;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,WAAW;EACvB,QAAQ;EACR,2BAA2B,EAAE,qBAAqB;EAClD,YAAY,EAAE,QAAQ;EACtB,WAAW,EAAE,QAAQ;EACrB,cAAc,EAAE,mBAAmB;EACnC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB,EAAE,qBAAqB;EAChD,yBAAyB,EAAE,aAAa;EACxC,0BAA0B,EAAE,mBAAmB;EAC/C,eAAe,EAAE,YAAY;EAC7B,iBAAiB;EACjB,mBAAmB,EAAE,eAAe;EACpC,2CAA2C,EAAE,cAAc;EAC3D,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ,EAAE,UAAU;EACpB,YAAY;EACZ,eAAe;EACf,mBAAmB,EAAE,eAAe;EACpC,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,mBAAmB;EACnC,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,YAAY,EAAE,SAAS;EACvB,yBAAyB,EAAE,aAAa;EACxC,+BAA+B,EAAE,qBAAqB;EACtD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB,EAAE,cAAc;EAClC,QAAQ,EAAE,cAAc;EACxB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C,EAAE,2BAA2B;EACvE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB,EAAE,cAAc;EAClC,mBAAmB,EAAE,eAAe;EACpC,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,gBAAgB;EAClC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;EACjD,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc,EAAE,eAAe;EAC/B,kDAAkD,EAAE,kCAAkC;AACxF;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,YAAY;EACZ,+BAA+B,EAAE,kBAAkB;EACnD,oBAAoB;EACpB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,OAAO;EACP,yBAAyB,EAAE,gBAAgB;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa,EAAE,QAAQ;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C,EAAE,2BAA2B;EACvE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,cAAc;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,UAAU;EACrB,aAAa,EAAE,QAAQ;EACvB,yBAAyB,EAAE,aAAa;EACxC,mBAAmB,EAAE,gBAAgB;EACrC,0CAA0C,EAAE,+BAA+B;EAC3E,2CAA2C,EAAE,cAAc;EAC3D,yBAAyB;AAC3B;;AAEA;EACE;;sCAEoC,EAAE,cAAc;EACpD,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA,kBAAkB;AAClB;EACE,WAAW,EAAE,SAAS;EACtB,YAAY,EAAE,SAAS;EACvB,mBAAmB,EAAE,eAAe;EACpC,gBAAgB;EAChB,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,UAAU;EACpB,kBAAkB,EAAE,SAAS;AAC/B;;AAEA;EACE,eAAe,EAAE,cAAc;EAC/B,gBAAgB,EAAE,cAAc;EAChC,cAAc,EAAE,mBAAmB;EACnC,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB,EAAE,eAAe;EACpC,iBAAiB,EAAE,kBAAkB;EACrC,eAAe,EAAE,gBAAgB;EACjC,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,mBAAmB;EACnC,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,UAAU;EACrB,8BAA8B,EAAE,8BAA8B;EAC9D,kBAAkB,EAAE,SAAS;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ,EAAE,UAAU;EACpB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,cAAc;EAChC,yBAAyB,EAAE,cAAc;EACzC,sBAAsB,EAAE,mBAAmB;AAC7C;;AAEA;EACE,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,eAAe,EAAE,gBAAgB;EACjC,cAAc,EAAE,mBAAmB;AACrC;;AAEA,8BAA8B;AAC9B;EACE,UAAU;EACV,oBAAoB;EACpB,YAAY,EAAE,QAAQ;EACtB,WAAW,EAAE,QAAQ;EACrB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,qBAAqB,EAAE,iBAAiB;EACxC,6BAA6B;EAC7B,2CAA2C,EAAE,cAAc;EAC3D,yBAAyB;EACzB,yBAAyB,EAAE,aAAa;AAC1C;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY,EAAE,QAAQ;EACtB,WAAW,EAAE,QAAQ;EACrB,qBAAqB,EAAE,iBAAiB;EACxC,yBAAyB,EAAE,kBAAkB;EAC7C;;qCAEmC,EAAE,cAAc;EACnD,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B,EAAE,kBAAkB;AACjD;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB;;mCAEiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uCAAuC,EAAE,gCAAgC;EACzE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB,EAAE,gBAAgB;EACrC;;wCAEsC;EACtC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB;cACY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;yBAEuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,OAAO;EACP,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf;;yBAEuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":[".menu-availability-overlay-wrapper {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1299;\n  background-color: rgba(0, 0, 0, 0.2); /* bg-black/20 */\n  backdrop-filter: blur(12px); /* backdrop-blur-sm */\n  display: flex;\n  justify-content: flex-end;\n}\n\n.menu-availability-overlay-backdrop {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.menu-availability-drawer {\n  position: relative;\n  z-index: 2;\n  width: 80%;\n  height: 100%;\n  background-color: #f8fafc; /* bg-slate-50 */\n  box-shadow: -10px 0 50px -12px rgba(0, 0, 0, 0.25); /* shadow-2xl */\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-left: 1px solid rgba(255, 255, 255, 0.2); /* border-l border-white/20 */\n  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,\n    sans-serif;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n/* Header / Top Bar */\n.menu-availability-header {\n  border-bottom: 1px solid #e2e8f0; /* border-slate-200 */\n  background-color: #ffffff; /* bg-white */\n  padding: 16px 24px; /* px-6 py-4 */\n  position: relative;\n  z-index: 20; /* above subbar so filter dropdown isn't clipped behind it */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px; /* gap-6 */\n}\n\n.menu-availability-title {\n  font-size: 20px; /* text-[20px] */\n  font-weight: 700; /* font-bold */\n  line-height: 1.25; /* leading-tight */\n  letter-spacing: -0.03em; /* tracking-[-0.03em] */\n  color: #0f172a; /* text-slate-900 */\n  margin: 0;\n}\n\n.menu-availability-close-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n  height: 40px;\n  width: 40px;\n  border-radius: 9999px; /* rounded-full */\n  color: #64748b; /* text-slate-500 */\n  background: transparent;\n  cursor: pointer;\n}\n\n.menu-availability-close-btn:hover {\n  background-color: #f1f5f9; /* hover:bg-slate-100 */\n}\n\n.menu-availability-close-icon {\n  height: 20px;\n  width: 20px;\n  stroke: currentColor;\n  stroke-width: 2;\n}\n\n.menu-availability-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Sub-header / Filters Bar */\n.menu-availability-subbar {\n  border-bottom: 1px solid #e2e8f0; /* border-slate-200 */\n  background-color: rgba(248, 250, 252, 0.8); /* bg-slate-50/80 */\n  backdrop-filter: blur(8px);\n  padding: 12px 24px; /* px-6 py-3 */\n  z-index: 10;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px; /* gap-4 */\n}\n\n.menu-availability-subbar-left {\n  display: flex;\n  align-items: center;\n  gap: 16px; /* gap-4 */\n}\n\n.menu-availability-tabs-container {\n  display: flex;\n  align-items: center;\n  border-radius: 16px; /* rounded-[16px] */\n  background-color: #f1f5f9; /* bg-slate-100 */\n  padding: 4px; /* p-1 */\n}\n\n.menu-availability-tab-btn {\n  padding: 6px 16px; /* px-4 py-1.5 */\n  border-radius: 12px; /* rounded-[12px] */\n  font-size: 14px; /* text-sm */\n  font-weight: 600; /* font-semibold */\n  transition: all 0.2s ease;\n  border: none;\n  cursor: pointer;\n  background: transparent;\n  color: #64748b; /* text-slate-500 */\n}\n\n.menu-availability-tab-btn:hover {\n  color: #334155; /* hover:text-slate-700 */\n}\n\n.menu-availability-tab-btn.active {\n  background-color: #ffffff; /* bg-white */\n  color: #0f172a; /* text-slate-900 */\n  box-shadow:\n    0 1px 3px 0 rgba(0, 0, 0, 0.1),\n    0 1px 2px -1px rgba(0, 0, 0, 0.1); /* shadow-sm */\n}\n\n.menu-availability-subbar-divider {\n  height: 32px; /* h-8 */\n  width: 1px; /* w-px */\n  background-color: #e2e8f0; /* bg-slate-200 */\n}\n\n.menu-availability-status-switch-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px; /* gap-3 */\n  padding: 0 8px; /* px-2 */\n}\n\n.menu-availability-status-switch-info {\n  min-width: 0;\n}\n\n.menu-availability-status-switch-title {\n  font-size: 14px; /* text-sm */\n  font-weight: 600; /* font-semibold */\n  line-height: 1; /* leading-none */\n  color: #059669; /* text-emerald-600 */\n  margin: 0;\n}\n\n.menu-availability-status-switch-subtitle {\n  margin-top: 4px; /* mt-1 */\n  font-size: 10px; /* text-[10px] */\n  color: #94a3b8; /* text-slate-400 */\n  margin-bottom: 0;\n}\n\n/* Switch Styles (emerald style switch) */\n.menu-availability-status-toggle {\n  all: unset;\n  display: inline-flex;\n  height: 17px; /* h-5 */\n  width: 33px; /* w-9 */\n  shrink: 0;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 9999px; /* rounded-full */\n  border: 2px solid transparent;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n  transition: all 0.2s ease;\n  background-color: #cbd5e1; /* slate-300 / bg-input */\n}\n\n.menu-availability-status-toggle.active {\n  background-color: #10b981; /* bg-emerald-500 */\n}\n\n.menu-availability-status-toggle-knob {\n  pointer-events: none;\n  display: block;\n  height: 16px; /* h-4 */\n  width: 16px; /* w-4 */\n  border-radius: 9999px; /* rounded-full */\n  background-color: #ffffff; /* bg-background */\n  box-shadow:\n    0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -4px rgba(0, 0, 0, 0.1); /* shadow-lg */\n  transition: transform 0.2s ease;\n  transform: translateX(0);\n}\n\n.menu-availability-status-toggle-knob.active {\n  transform: translateX(16px); /* translate-x-4 */\n}\n\n.menu-availability-subbar-right {\n  display: flex;\n  align-items: center;\n  gap: 12px; /* gap-3 */\n}\n\n.menu-availability-search-wrapper {\n  position: relative;\n  width: 256px; /* w-64 */\n}\n\n.menu-availability-search-svg {\n  position: absolute;\n  left: 12px; /* left-3 */\n  top: 50%;\n  transform: translateY(-50%); /* -translate-y-1/2 */\n  height: 16px; /* h-4 */\n  width: 16px; /* w-4 */\n  color: #94a3b8; /* text-slate-400 */\n  pointer-events: none;\n}\n\n.menu-availability-search-input {\n  display: flex;\n  width: 100%;\n  border: 1px solid #e2e8f0; /* border-slate-200 */\n  background-color: #ffffff; /* bg-white */\n  padding: 8px 12px 8px 36px; /* px-3 py-1 pl-9 */\n  font-size: 14px; /* text-sm */\n  line-height: 1.25;\n  border-radius: 20px; /* rounded-xl */\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.menu-availability-search-input:focus {\n  border-color: #94a3b8;\n  box-shadow: 0 0 0 2px rgba(148, 163, 184, 0.15);\n}\n\n/* Add Menu Button */\n.menu-availability-add-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px; /* gap-2 */\n  height: 38px;\n  padding: 0 16px;\n  border-radius: 12px; /* rounded-xl */\n  font-size: 14px; /* text-sm */\n  font-weight: 600; /* font-semibold */\n  color: #0f172a; /* text-slate-900 */\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.menu-availability-add-btn:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.menu-availability-add-icon {\n  width: 16px;\n  height: 16px;\n  stroke: currentColor;\n  stroke-width: 2.5;\n}\n\n/* Content Area */\n.menu-availability-content {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* Categories Sidebar */\n.menu-availability-categories {\n  width: 256px; /* w-64 */\n  background-color: #ffffff; /* bg-white */\n  border-right: 1px solid #e2e8f0; /* border-slate-200 */\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding: 24px 16px; /* py-6 px-4 */\n  gap: 4px; /* space-y-1 */\n  height: 100%;\n}\n\n.menu-availability-categories::-webkit-scrollbar {\n  width: 6px;\n}\n\n.menu-availability-categories::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.menu-availability-categories::-webkit-scrollbar-thumb {\n  background-color: rgba(148, 163, 184, 0.5); /* slate-400 with opacity */\n  border-radius: 20px;\n}\n\n.menu-availability-categories::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(148, 163, 184, 0.8);\n}\n\n.menu-availability-category-item {\n  width: 100%;\n  text-align: left;\n  padding: 12px 16px; /* px-4 py-3 */\n  border-radius: 20px; /* rounded-xl */\n  font-size: 14px; /* text-sm */\n  font-weight: 500; /* font-medium */\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  color: #475569; /* text-slate-600 */\n}\n\n.menu-availability-category-item:hover {\n  background-color: #f8fafc; /* hover:bg-slate-50 */\n  color: #0f172a; /* hover:text-slate-900 */\n}\n\n.menu-availability-category-item.active {\n  background-color: #0f172a; /* bg-slate-900 */\n  color: #ffffff; /* text-white */\n  box-shadow: 0 10px 15px -3px rgba(15, 23, 42, 0.2); /* shadow-lg shadow-slate-900/20 */\n}\n\n.menu-availability-category-chevron {\n  width: 16px; /* w-4 h-4 */\n  height: 16px;\n  color: rgba(255, 255, 255, 0.5); /* text-white/50 */\n  stroke: currentColor;\n  stroke-width: 2;\n}\n\n/* Products List Area */\n.menu-availability-products {\n  flex: 1;\n  background-color: #f8fafc; /* bg-slate-50 */\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding: 32px; /* p-8 */\n}\n\n.menu-availability-products::-webkit-scrollbar {\n  width: 6px;\n}\n\n.menu-availability-products::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.menu-availability-products::-webkit-scrollbar-thumb {\n  background-color: rgba(148, 163, 184, 0.5); /* slate-400 with opacity */\n  border-radius: 20px;\n}\n\n.menu-availability-products::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(148, 163, 184, 0.8);\n}\n\n.menu-availability-products-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px; /* space-y-4 */\n}\n\n/* Product Card */\n.menu-availability-product-row {\n  display: flex;\n  align-items: center;\n  gap: 24px; /* gap-6 */\n  padding: 16px; /* p-4 */\n  background-color: #ffffff; /* bg-white */\n  border-radius: 16px; /* rounded-2xl */\n  border: 1px solid rgba(226, 232, 240, 0.6); /* border border-slate-200/60 */\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n  transition: all 0.2s ease;\n}\n\n.menu-availability-product-row:hover {\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.05),\n    0 2px 4px -2px rgba(0, 0, 0, 0.05); /* shadow-md */\n  border-color: #cbd5e1; /* hover:border-slate-300 */\n}\n\n/* Product Image */\n.menu-availability-product-image-container {\n  width: 64px; /* w-16 */\n  height: 64px; /* h-16 */\n  border-radius: 20px; /* rounded-xl */\n  overflow: hidden;\n  background-color: #f1f5f9; /* bg-slate-100 */\n  flex-shrink: 0;\n}\n\n.menu-availability-product-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Details */\n.menu-availability-product-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.menu-availability-product-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px; /* gap-2 */\n  margin-bottom: 4px; /* mb-1 */\n}\n\n.menu-availability-product-name {\n  font-size: 16px; /* text-base */\n  font-weight: 700; /* font-bold */\n  color: #0f172a; /* text-slate-900 */\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.menu-availability-product-badge {\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 20px; /* rounded-md */\n  padding: 2px 10px; /* px-2.5 py-0.5 */\n  font-size: 10px; /* text-[10px] */\n  font-weight: 600; /* font-semibold */\n  color: #64748b; /* text-slate-500 */\n  border: 1px solid #e2e8f0; /* border-slate-200 */\n}\n\n.menu-availability-product-price {\n  font-size: 14px; /* text-sm */\n  font-weight: 600; /* font-semibold */\n  color: #475569; /* text-slate-600 */\n  margin: 0;\n}\n\n/* Status / Switch Container */\n.menu-availability-product-status-container {\n  display: flex;\n  align-items: center;\n  gap: 16px; /* gap-4 */\n  border-left: 1px solid #f1f5f9; /* border-l border-slate-100 */\n  padding-left: 24px; /* pl-6 */\n  flex-shrink: 0;\n}\n\n.menu-availability-product-status-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px; /* gap-1 */\n  margin-right: 8px; /* mr-2 */\n}\n\n.menu-availability-status-label-text {\n  font-size: 12px; /* text-xs */\n  font-weight: 700; /* font-bold */\n  text-transform: uppercase; /* uppercase */\n  letter-spacing: 0.05em; /* tracking-wider */\n}\n\n.menu-availability-status-label-text.on-sale {\n  color: #059669; /* text-emerald-600 */\n}\n\n.menu-availability-status-label-text.unavailable {\n  color: #94a3b8; /* text-slate-400 */\n}\n\n.menu-availability-status-subtext {\n  font-size: 10px; /* text-[10px] */\n  color: #94a3b8; /* text-slate-400 */\n}\n\n/* Toggle Switch inside card */\n.menu-availability-switch-button {\n  all: unset;\n  display: inline-flex;\n  height: 20px; /* h-5 */\n  width: 36px; /* w-9 */\n  shrink: 0;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 9999px; /* rounded-full */\n  border: 2px solid transparent;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n  transition: all 0.2s ease;\n  background-color: #cbd5e1; /* bg-input */\n}\n\n.menu-availability-switch-button.active {\n  background-color: #10b981; /* bg-emerald-500 */\n}\n\n.menu-availability-switch-button-knob {\n  pointer-events: none;\n  display: block;\n  height: 16px; /* h-4 */\n  width: 16px; /* w-4 */\n  border-radius: 9999px; /* rounded-full */\n  background-color: #ffffff; /* bg-background */\n  box-shadow:\n    0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -4px rgba(0, 0, 0, 0.1); /* shadow-lg */\n  transition: transform 0.2s ease;\n  transform: translateX(0);\n}\n\n.menu-availability-switch-button-knob.active {\n  transform: translateX(16px); /* translate-x-4 */\n}\n\n.menu-availability-oos-badge {\n  align-items: center;\n  display: inline-flex;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 4px 10px;\n  border-radius: 9999px;\n  background-color: #fee2e2;\n  color: #ef4444;\n  border: 1px solid #fecaca;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.menu-availability-oos-badge:hover {\n  background-color: #fecaca;\n  border-color: #fca5a5;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.mad-popover-content {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background-color: #ffffff;\n  min-width: 200px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  box-shadow:\n    0 4px 6px -1px rgb(0 0 0 / 0.1),\n    0 2px 4px -2px rgb(0 0 0 / 0.1);\n}\n\n.mad-popover-variant-row {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.mad-popover-variant-name {\n  font-size: 12px;\n  font-weight: 700;\n  color: #334155;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding-bottom: 4px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.mad-popover-channel-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.mad-popover-channel-tag {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background-color: #fef2f2;\n  color: #ef4444;\n  border: 1px solid #fee2e2;\n  white-space: nowrap;\n}\n\n/* Variant Modal */\n.menu-availability-variant-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(15, 23, 42, 0.3); /* Slate-900 with transparency */\n  backdrop-filter: blur(4px);\n  z-index: 1399;\n}\n\n.menu-availability-variant-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 500px;\n  max-width: 90%;\n  max-height: 80vh;\n  background-color: #ffffff;\n  border-radius: 20px; /* rounded-2xl */\n  box-shadow:\n    0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  z-index: 1400;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,\n    sans-serif;\n}\n\n.menu-availability-variant-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background-color: #ffffff;\n}\n\n.menu-availability-variant-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.menu-availability-variant-close {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 9999px;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.menu-availability-variant-close:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n.menu-availability-variant-content {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n  background-color: #f8fafc;\n}\n\n.menu-availability-variant-section {\n  margin-bottom: 24px;\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 16px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.02);\n}\n\n.menu-availability-variant-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.menu-availability-variant-section-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.menu-availability-variant-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.menu-availability-channel-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background-color: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n}\n\n.menu-availability-channel-item.toggling {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.menu-availability-channel-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.menu-availability-channel-sale-price {\n  font-size: 14px;\n  font-weight: 700;\n  color: #059669;\n  margin-left: auto;\n  margin-right: 16px;\n}\n\n.menu-availability-channel-status-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.menu-availability-channel-status {\n  font-size: 11px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.menu-availability-channel-status.in-stock {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.menu-availability-channel-status.out-of-stock {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n/* Modal Actions */\n.menu-availability-variant-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #e2e8f0;\n  background-color: #ffffff;\n}\n\n.menu-availability-btn {\n  padding: 10px 18px;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n}\n\n.menu-availability-btn-mark-in-stock {\n  background-color: #d1fae5;\n  border-color: #a7f3d0;\n  color: #065f46;\n}\n\n.menu-availability-btn-mark-in-stock:hover:not(:disabled) {\n  background-color: #059669;\n  color: #ffffff;\n  border-color: #059669;\n}\n\n.menu-availability-btn-mark-in-stock:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.menu-availability-btn-mark-oos {\n  background-color: #fee2e2;\n  border-color: #fecaca;\n  color: #991b1b;\n}\n\n.menu-availability-btn-mark-oos:hover:not(:disabled) {\n  background-color: #dc2626;\n  color: #ffffff;\n  border-color: #dc2626;\n}\n\n.menu-availability-btn-mark-oos:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.menu-availability-btn-cancel {\n  background-color: #f1f5f9;\n  border-color: #e2e8f0;\n  color: #475569;\n}\n\n.menu-availability-btn-cancel:hover {\n  background-color: #e2e8f0;\n  color: #0f172a;\n}\n\n/* Loading State */\n.menu-availability-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n}\n\n.menu-availability-loading-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n/* No Results */\n.menu-availability-no-results {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  color: #64748b;\n}\n\n.menu-availability-no-results p {\n  margin: 8px 0 0 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* Info icon tooltip */\n.mad-info-tooltip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: default;\n  flex-shrink: 0;\n}\n\n.mad-info-tooltip-box {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: #1e293b;\n  color: #f8fafc;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.5;\n  padding: 7px 12px;\n  border-radius: 8px;\n  width: max-content;\n  max-width: 600px;\n  white-space: normal;\n  word-break: break-word;\n  text-align: center;\n  pointer-events: none;\n  z-index: 9999;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);\n  animation: mad-tooltip-in 0.12s ease forwards;\n}\n\n.mad-info-tooltip-box::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #1e293b;\n}\n\n@keyframes mad-tooltip-in {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* ── Dark mode ── */\n.dark .menu-availability-drawer {\n  background-color: #0f172a;\n  border-left-color: #334155;\n}\n\n.dark .menu-availability-header {\n  background-color: #1e293b;\n  border-bottom-color: #334155;\n}\n\n.dark .menu-availability-title {\n  color: #f1f5f9;\n}\n\n.dark .menu-availability-close-btn {\n  color: #94a3b8;\n}\n\n.dark .menu-availability-close-btn:hover {\n  background-color: #334155;\n}\n\n.dark .menu-availability-add-btn {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\n.dark .menu-availability-add-btn:hover {\n  background-color: #334155;\n  border-color: #475569;\n}\n\n.dark .menu-availability-subbar {\n  background-color: rgba(15, 23, 42, 0.8);\n  border-bottom-color: #334155;\n}\n\n.dark .menu-availability-tabs-container {\n  background-color: #0f172a;\n}\n\n.dark .menu-availability-tab-btn {\n  color: #64748b;\n}\n\n.dark .menu-availability-tab-btn:hover {\n  color: #cbd5e1;\n}\n\n.dark .menu-availability-tab-btn.active {\n  background-color: #1e293b;\n  color: #f1f5f9;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.4);\n}\n\n.dark .menu-availability-subbar-divider {\n  background-color: #334155;\n}\n\n.dark .menu-availability-status-switch-subtitle {\n  color: #64748b;\n}\n\n.dark .menu-availability-search-input {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\n.dark .menu-availability-search-input::placeholder {\n  color: #64748b;\n}\n\n.dark .menu-availability-search-input:focus {\n  border-color: #475569;\n}\n\n.dark .menu-availability-categories {\n  background-color: #1e293b;\n  border-right-color: #334155;\n}\n\n.dark .menu-availability-category-item {\n  color: #94a3b8;\n}\n\n.dark .menu-availability-category-item:hover {\n  background-color: #0f172a;\n  color: #e2e8f0;\n}\n\n.dark .menu-availability-category-item.active {\n  background-color: #3b82f6;\n  color: #ffffff;\n}\n\n.dark .menu-availability-products {\n  background-color: #0f172a;\n}\n\n.dark .menu-availability-product-row {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .menu-availability-product-row:hover {\n  border-color: #475569;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.3);\n}\n\n.dark .menu-availability-product-image-container {\n  background-color: #334155;\n}\n\n.dark .menu-availability-product-name {\n  color: #f1f5f9;\n}\n\n.dark .menu-availability-product-badge {\n  color: #94a3b8;\n  border-color: #334155;\n  background: #0f172a;\n}\n\n.dark .menu-availability-product-price {\n  color: #94a3b8;\n}\n\n.dark .menu-availability-product-status-container {\n  border-left-color: #334155;\n}\n\n.dark .menu-availability-status-subtext {\n  color: #64748b;\n}\n\n.dark .menu-availability-no-results {\n  color: #64748b;\n}\n\n/* Variant modal */\n.dark .menu-availability-variant-modal {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .menu-availability-variant-header {\n  background-color: #1e293b;\n  border-bottom-color: #334155;\n}\n\n.dark .menu-availability-variant-title {\n  color: #f1f5f9;\n}\n\n.dark .menu-availability-variant-close {\n  color: #94a3b8;\n}\n\n.dark .menu-availability-variant-close:hover {\n  background-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .menu-availability-variant-content {\n  background-color: #0f172a;\n}\n\n.dark .menu-availability-variant-section {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .menu-availability-variant-section-title {\n  color: #f1f5f9;\n}\n\n.dark .menu-availability-channel-item {\n  background-color: #0f172a;\n  border-color: #334155;\n}\n\n.dark .menu-availability-channel-name {\n  color: #e2e8f0;\n}\n\n.dark .menu-availability-variant-actions {\n  background-color: #1e293b;\n  border-top-color: #334155;\n}\n\n.dark .menu-availability-btn-cancel {\n  background-color: #334155;\n  border-color: #475569;\n  color: #94a3b8;\n}\n\n.dark .menu-availability-btn-cancel:hover {\n  background-color: #475569;\n  color: #f1f5f9;\n}\n\n/* mad-dialog */\n.dark .mad-dialog {\n  background: #0f172a;\n}\n\n.dark .mad-dialog-header {\n  background: #1e293b;\n  border-bottom-color: #334155;\n}\n\n.dark .mad-dialog-title {\n  color: #f1f5f9;\n}\n\n.dark .mad-dialog-body {\n  background: #0f172a;\n}\n\n.dark .mad-dialog-section {\n  background: #1e293b;\n}\n\n.dark .mad-section-heading {\n  color: #e2e8f0;\n}\n\n.dark .mad-section-hint {\n  color: #64748b;\n}\n\n.dark .mad-vr-row {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n.dark .mad-vr-row:hover:not(.mad-vr-row--checked) {\n  border-color: #475569;\n}\n\n.dark .mad-vr-row--checked {\n  background: #2d1b1b;\n  border-color: #7f1d1d;\n}\n\n.dark .mad-vr-name {\n  color: #e2e8f0;\n}\n\n.dark .mad-variant-price {\n  color: #64748b;\n}\n\n.dark .mad-vr-channels {\n  border-top-color: #334155;\n}\n\n.dark .mad-ch-name {\n  color: #94a3b8;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .menu-availability-drawer {\n    width: 100%;\n  }\n\n  .menu-availability-subbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .menu-availability-subbar-left {\n    flex-wrap: wrap;\n  }\n\n  .menu-availability-categories {\n    width: 180px;\n  }\n\n  .menu-availability-search-wrapper {\n    width: 100%;\n  }\n}\n\n/* ── Variant Modal (mad-dialog) ── */\n.mad-dialog-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(2px);\n}\n\n.mad-dialog {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1401;\n  width: 100%;\n  max-width: 640px;\n  background: #f8fafc;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n}\n\n.mad-dialog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px;\n  background: #fff;\n  border-bottom: 1px solid #f1f5f9;\n  flex-shrink: 0;\n}\n\n.mad-dialog-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  letter-spacing: -0.02em;\n}\n\n.mad-dialog-close-abs {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  display: grid;\n  place-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.15s ease;\n}\n\n.mad-dialog-close-abs:hover {\n  opacity: 1;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.mad-dialog-body {\n  overflow-y: auto;\n  background: #f8fafc;\n}\n\n.mad-dialog-section {\n  background: #fff;\n  padding: 24px;\n}\n\n.mad-section-heading {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0f172a;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin: 0 0 16px 0;\n}\n\n.mad-section-hint {\n  font-size: 12px;\n  color: #94a3b8;\n  margin: 12px 0 0 0;\n}\n\n/* Variant rows */\n.mad-variant-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.mad-vr-row {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease;\n  overflow: hidden;\n}\n\n.mad-vr-row:hover:not(.mad-vr-row--checked) {\n  border-color: #cbd5e1;\n}\n\n.mad-vr-row--checked {\n  background: #fff1f2;\n  border-color: #fecdd3;\n}\n\n.mad-vr-top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n}\n\n.mad-vr-checkbox {\n  display: grid;\n  place-content: center;\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  border-radius: 30px;\n  border: 1px solid #79adec;\n  background: #fff;\n  color: transparent;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n  flex-shrink: 0;\n}\n\n.mad-vr-checkbox--checked {\n  background: #dc2626;\n  border-color: #dc2626;\n  color: #fff;\n}\n\n.mad-vr-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #334155;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.mad-vr-name--checked {\n  color: #991b1b;\n}\n\n.mad-variant-price {\n  font-size: 13px;\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n/* Status badges */\n.mad-status-badge {\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  padding: 2px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  border: 1px solid transparent;\n  flex-shrink: 0;\n}\n\n.mad-status--on-sale {\n  background: #ecfdf5;\n  color: #059669;\n  border-color: #a7f3d0;\n}\n\n.mad-status--oos {\n  background: #fff7ed;\n  color: #ea580c;\n  border-color: #fed7aa;\n}\n\n/* Channels sub-section inside variant row */\n.mad-vr-channels {\n  border-top: 1px solid #f1f5f9;\n  padding: 8px 14px 10px 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: rgba(0, 0, 0, 0.01);\n}\n\n.mad-vr-row--checked .mad-vr-channels {\n  border-top-color: #fecdd3;\n  background: rgba(254, 202, 202, 0.08);\n}\n\n.mad-vr-channel {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  transition: opacity 0.15s ease;\n}\n\n.mad-vr-channel.toggling {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.mad-ch-name-price-container {\n  flex: 1;\n  display: flex;\n  gap: 0.25rem;\n}\n\n.mad-ch-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n  /* flex: 1; */\n}\n\n.mad-ch-price {\n  font-size: 12px;\n  font-weight: 700;\n  color: oklch(70.4% 0.04 256.788);\n}\n\n.mad-ch-status {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 20px;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.mad-ch-status.in-stock {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.mad-ch-status.out-of-stock {\n  background: hsl(210 40% 96.1%);\n  color: hsl(222 47% 11%);\n}\n\n/* Footer */\n.mad-dialog-footer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 24px;\n  background: #fff;\n  border-top: 1px solid #f1f5f9;\n  flex-shrink: 0;\n}\n\n.mad-footer-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 20px;\n  height: 44px;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  flex: 1;\n  border: 1px solid transparent;\n  transition: background 0.15s ease;\n}\n\n.mad-footer-btn--cancel {\n  background: #fff;\n  border-color: #e2e8f0;\n  color: #475569;\n}\n\n.mad-footer-btn--cancel:hover {\n  background: #f8fafc;\n}\n\n.mad-footer-btn--confirm {\n  background: #0f172a;\n  color: #fff;\n  border-color: #0f172a;\n}\n\n.mad-footer-btn--confirm:hover:not(:disabled) {\n  background: #1e293b;\n}\n\n.mad-footer-btn--confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── Variant group labels (shown when product has multiple variants) ── */\n.mad-vs-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.mad-vs-header {\n  padding: 4px 2px 2px 2px;\n}\n\n.mad-vs-name {\n  font-size: 11px;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n}\n\n/* ── Channel checkbox rows ── */\n.mad-ch-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 14px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease;\n  user-select: none;\n}\n\n.mad-ch-row:hover:not(.mad-ch-row--checked):not(.mad-ch-row--toggling) {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n.mad-ch-row--checked {\n  background: #fff1f2;\n  border-color: #fecdd3;\n}\n\n.mad-ch-row--toggling {\n  opacity: 0.5;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
